import React from 'react';
import { Box, Icon } from '@amzn/awsui-components-react';
import './DerivedAllocationSheet.scss';

/**
 * A step's guidance under its header, shown as an info line: the info icon, then small info text that wraps beside
 * it at word breaks, however long the guidance is.
 */
export default function DasStepInfo({ children }: { children: React.ReactNode }) {
    return (
        <div data-class="dasStepInfo" className="dasStepInfo">
            <Icon name="status-info" variant="link" />
            <Box variant="small" color="text-status-info">{children}</Box>
        </div>
    );
}
